/*
Classe de Pedido
*/
export class Pedido {
    id?: number;
    // tslint:disable-next-line: variable-name
    total_pedido?: number;
    impresso?: boolean;
    cupom?: string;
    data?: Date;
    dominio?: string;
    status?: string;
    token?: string;
    //VIRA O NOME DO CLIENTE
    id_consumidor?: string;
    erro_pdv?: boolean;
    pedido?: string;
    //Realmente o id
    consumidor_id?: string;
    rota_impressao?: string;
    cupom_reduzido?: string;
    motoboy?: string;
    motoboyNome?: string;

    encomenda?: boolean;
    periodo_encomenda?: string;
    data_encomenda?: string;

    tem_ordem?: string;
}
